import { Person } from "@wingspanhq/wingspan-api-sdk";
import { CountryCode } from "libphonenumber-js";
import { getPersonFormEmptyValues } from "./emptyValues";
import { FormPartialDataPerson, FormPartialPersonType } from ".";
import { phoneNumberToFormData } from "../FormPartialPhoneNumber";

export function getProfileDataPersonV3(props: {
  type: FormPartialPersonType;
  person?: Person;
}): Partial<FormPartialDataPerson> {
  const { type, person } = props;

  if (type === "BeneficialOwner") {
    return {};
  }

  const complianceEntity = person?.complianceEntity;
  const address = complianceEntity?.physicalAddress;
  const country =
    complianceEntity?.jurisdictionCountry || address?.country || "US";
  const storedPhone = complianceEntity?.phoneNumber || person?.phone;

  return {
    address: {
      ...getPersonFormEmptyValues().address,
      addressLine1: address?.line1 || "",
      addressLine2: address?.line2 || "",
      city: address?.city || "",
      state: address?.state || "",
      postalCode: address?.postalCode || ""
    },
    birthday: complianceEntity?.dateOfBirth || undefined,
    country,
    firstName: complianceEntity?.individualLegalName?.givenName || undefined,
    lastName: complianceEntity?.individualLegalName?.familyName || undefined,
    middleName: complianceEntity?.individualLegalName?.middleNames || undefined,
    email: complianceEntity?.email || person?.email || undefined,
    phone: storedPhone
      ? phoneNumberToFormData(storedPhone, country as CountryCode)
      : undefined,
    jobTitle: complianceEntity?.occupation || undefined
  };
}
